<template>
  <div class="menu-tabs">
    <a v-for="(item, index) in navigations" :key="`menu-tab-item-${index}`"
       :class="['tab-item', { active: item.routes.includes(activeTab) }, { 'border-first': item.first }, { 'border-last': item.last}]"
       @click="goto(item)"
    >
      <i :class="['icon', item.icon]" />
      <span class="lg:hidden">{{ item.labelDesktop }}</span>
      <span class="hidden lg:block">{{ item.labelMobile }}</span>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['data'],
  data() {
    return {
      menuNavigations: [
        {
          icon: 'icon-bor-information',
          labelDesktop: '基本情報',
          labelMobile: '基本情報',
          active: true,
          routes: ['/menus/:menuNo'],
          query: this.$route.query
        },
        {
          icon: 'icon-bor-plan',
          labelDesktop: 'プラン',
          labelMobile: 'プラン',
          active: false,
          routes: ['/tour/menus/:menuNo/plans', '/tour/menus/:menuNo/plans/:planId'],
          query: this.$route.query
        },
        {
          icon: 'icon-bor-img',
          labelDesktop: 'フォトギャラリー',
          labelMobile: 'フォト',
          active: false,
          routes: ['/menus/:menuNo/photo-gallery'],
          query: this.$route.query
        },
        {
          icon: 'icon-bor-care',
          labelDesktop: '設備・サービス詳細',
          labelMobile: '設備・詳細',
          active: false,
          routes: ['/menus/:menuNo/equipments'],
          query: this.$route.query
        }
      ]
    }
  },
  mounted() {
    if (this.data) {
      this.menuNavigations = _.cloneDeep(this.data)
    }
  },
  computed: {
    activeTab() {
      return this.$route.path
    },
    navigations() {
      const params = this.$route.params
      const menuNavigaions = _.cloneDeep(this.menuNavigations)
      return menuNavigaions.map(m => {
        m.routes = this.formatRoutePattern(m.routes, params)
        return m
      })
    }
  },
  watch: {
  },
  methods: {
    formatRoutePattern(routes) {
      const { menuNo, planId, roomId } = this.$route.params
      return routes.map(route => {
        let formatedPath = String(route)
        if (formatedPath.indexOf(':menuNo') >= 0) {
          formatedPath = formatedPath.replace(':menuNo', menuNo)
        }
        if (formatedPath.indexOf(':planId') >= 0) {
          formatedPath = formatedPath.replace(':planId', planId)
        }
        if (formatedPath.indexOf(':roomId') >= 0) {
          formatedPath = formatedPath.replace(':roomId', roomId)
        }
        return formatedPath 
      })
    },
    goto(nav) {
      if (nav.routes.length) {
        this.$router.push({path: this.formatRoutePattern(nav.routes)[0]})
      } else if (nav.href) {
        if (nav._bank) {
          window.open(nav.href)
        } else {
          location.href(nav.href)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
